export default {
  main: {
    site_id: 1863400,
    title: 'Terminal PRO Demo',
    terminalId: 36435,
    isTicketsCheckable: true,
    ticketAvailableViewMode: ['card'],
    enableMultipleTicketPay: false,
    alwaysShowCheckTicket: true,
    enableTicketAutoCashoutAmountUpdate: false,
    enableTicketPopupFlow: true,
    enableTicketTimer: false,
    restrictedAdminPrintableTicketsCount: 5,
    enableCpfAutoFill: true,
    depositWithoutLogin: {
      disabled: true,
      text: "to deposit with PIX please login",
    },
    enableRegistration: true,
    signInType: 'email',
    cpfType: 'cpfs',
    registrationSteps: [{ name: 'cpf_auto_fill' }, { name: 'basic_information' }],
    staffPassword: '0',
    homeMediaSlides: [
      {
        type: 'boosted',
        path: 'betting/prematch/all/boosted/all/all',
      },
      {
        type: 'multiple',
        path: 'betting/prematch/all/multiples',
      },
      {
        type: 'sport',
        path: 'betting/prematch',
      },
    ],
    websitePasswordHash: 'c06097acc6341402203d9942c51438d628271fef4f8a93fba7c6f9d20a804eaa',
    logoSize: 'extra-huge-with-height',
    showEventTypeFilter: true,
    cashoutCommissionPercent: 4,
    resultPageVirtualsId: [150, 197, 209, 118, 54, 55, 31, 184, 181],
    showTicketAfterPay: 10000,
    popupForTerminalLock: false,
    availableLanguages: {
      '@replace': true,
      'pt-br': {
        short: 'PT-BR',
        name: 'BRA',
        order: 1,
      },
    },
  },
  disableCashoutAfterLogin: false,
  depositeServiceID: 16900,
  depositMethods: [
    {
      pic: "pix.png",
      type: "pix",
      service: "PARAI",
      handlerPopup: "POPUPS.DEPOSIT_BY_PIX",
      minAmount: 20,
      enabled: true,
    },
  ],
  cashoutMethods: [
    {
      pic: "pix.png",
      type: "pix",
      service: "PARAI",
      handlerPopup: "POPUPS.CASHOUT_BY_PIX",
      isAmountEditable: true,
    },
  ],
  userSection: {
    sections: ['changePassword', 'betHistory'],
  },
  env: {
    lang: 'pt-br',
  },
  disableTicketsFlow: true,

  lastTicketButtons: [
    {
      name: 'Bet tickets',
      type: 'betTicket',
      hideOnRestrictMode: false,
    },
    {
      name: 'Lottery tickets',
      type: 'lotteryTicket',
      hideOnRestrictMode: true,
    },
    {
      name: 'Cash-out',
      type: 'cashoutTicket',
      hideOnRestrictMode: false,
    },
  ],
  availableOdds: [
    {
      odds: 'american',
      title: 'American',
      enabled: true,
    },
    {
      odds: 'decimal',
      title: 'Decimal',
      enabled: true,
    },
    {
      odds: 'malay',
      title: 'Malaya',
      enabled: true,
    },
    {
      odds: 'indo',
      title: 'indo',
      enabled: true,
    },
    {
      odds: 'hongkong',
      title: 'hongkong',
      enabled: true,
    },
    {
      odds: 'fractional',
      title: 'Fractional',
      enabled: true,
    },
  ],
  routes: [
    {
      name: 'Casino',
      url: 'casino',
      type: 'casino',
      enabled: true,
    },
    {
      url: 'betting/prematch/virtuals',
      type: 'virtuals',
      name: 'Virtuals',
      enabled: true,
      icon: 'casino-categories-VirtualBetting',
      nestedItems: [
        {
          name: 'Games',
          url: 'betting/prematch/virtuals',
          enabled: true,
          type: 'virtuals',
          icon: '',
        },
        {
          name: 'Results',
          type: 'virtual-results',
          url: 'betting/virtual-results',
          enabled: true,
          icon: '',
        },
      ],
    },
    {
      url: "tickets",
      name: "Tickets",
      enabled: true,
    },
  ],
  defaultTerminalParams: {
    pid: 18763400,
    tid: 36389,
    token: '2pDjHA==',
    currency: 'BRL',
  },
};
